'use strict';

angular.module('ntmApp').factory('ProfileHelper', ['ListGridHelper', function (ListGridHelper) {

    var helper = {};

    helper.pageId = null;
    helper.keyFilters = null;
    helper.entities = null;

    helper.getTabCount = function (tab) {
        
        if (ListGridHelper.doesGridContainRoomHistory(tab.sectionId)) {
            var filteredItems = ListGridHelper.getFilteredRoomHistoryRecords(tab.items, false, tab.sectionId, true);
            return filteredItems.length || 0;
        }

        return tab.items.length;
    };

    return helper;

}]);